import axios from 'axios'
import { createResource } from '../utils/resource'
import { IUser } from '@/shared/model/user.model'
import { getLocale } from '@/i18n'

const baseResource = createResource('course', {})

const courseStore = {
  ...baseResource,
  actions: {
    ...baseResource.actions,
    async joinCourse({ commit }: any, { id }: any) {
      const result = await axios.put(`/api/course/join/${id}`)
      return result.data ?? []
    },

    async deleteParticipantFromCourse({ commit }: any, { courseId, participantId }: { courseId: string, participantId: string }) {
      const result = await axios.patch(`/api/course/deleteParticipant/${courseId}?participant=${participantId}`)
      return result.data ?? []
    },

    async updateParticipants({ commit }: any, { courseId, participants }: { courseId: string, participants: IUser[] }) {
      const result = await axios.patch(`/api/course/${courseId}/participants`, { participants })
      return result.data ?? []
    },

    // academy courses assignable to this course (backend filters: unpublished, flagged, matching level)
    async getAssignableAcademyCourses({}, { courseId }: { courseId: string }) {
      const result = await axios.get(`/api/course/${courseId}/assignable-academy-courses`)
      return result.data ?? []
    },

    async assignAcademyCourse({}, { courseId, academyCourse, type, language }: { courseId: string, academyCourse: string, type: string, language: string }) {
      const result = await axios.put(`/api/course/${courseId}/academy-courses`, { academyCourse, type, language })
      return result.data
    },

    async updateAcademyCourseType({}, { courseId, assignmentId, type }: { courseId: string, assignmentId: string, type: string }) {
      const result = await axios.patch(`/api/course/${courseId}/academy-courses/${assignmentId}`, { type })
      return result.data
    },

    async removeAcademyCourse({}, { courseId, assignmentId }: { courseId: string, assignmentId: string }) {
      const result = await axios.delete(`/api/course/${courseId}/academy-courses/${assignmentId}`)
      return result.data
    },

    async getExamResults({}, { courseId }: { courseId: string }) {
      const result = await axios.get(`/api/course/${courseId}/exam-results`)
      return result.data
    },

    // URL that streams the participant's result PDF on the fly (nothing stored). Language follows the admin locale.
    examResultPdfUrl({}, { courseId, attemptId }: { courseId: string, attemptId: string }) {
      return `/api/course/${courseId}/exam-results/${attemptId}/pdf?lang=${getLocale()}`
    }
  }
}

export default courseStore
